import React from 'react';

export const HomeIcon = () => {
    return (
        <svg
            width="29"
            height="24"
            viewBox="0 0 29 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0 14.1882C0 14.2625 0.018583 14.3089 0.0557491 14.3275C0.0743322 14.3461 0.111498 14.3554 0.167247 14.3554H4.76655V23.4983V23.554V23.5819C4.76655 23.7863 4.88734 23.9164 5.12892 23.9721C5.16609 23.9907 5.22184 24 5.29617 24H11.5401C11.633 24 11.7166 23.9721 11.7909 23.9164C11.8746 23.8606 11.921 23.7863 11.9303 23.6934C11.9489 23.6562 11.9582 23.6005 11.9582 23.5261V16.3902V16.3066H12.0139H14.5226H16.8084V23.5819C16.8362 23.7956 16.9663 23.935 17.1986 24H23.4704C23.7027 23.9628 23.8328 23.8328 23.8606 23.6098V23.4983C23.8606 17.5889 23.8699 14.5598 23.8885 14.4111V14.3833V14.3554H28.2927H28.4321C28.4878 14.3275 28.5157 14.2904 28.5157 14.2439V14.1603L28.4599 14.1045C28.4506 14.0952 28.4413 14.0767 28.4321 14.0488C28.4228 14.0209 28.4135 14.0023 28.4042 13.993L14.885 0.250871L14.7456 0.111498C14.597 0.0371661 14.4855 0 14.4112 0C14.3554 0 14.3089 0.00929152 14.2718 0.0278746C14.216 0.0278746 14.151 0.0650406 14.0767 0.139373L0.111498 13.993C0.102207 14.0023 0.0882695 14.0209 0.0696864 14.0488C0.0511034 14.0767 0.0371661 14.0952 0.0278746 14.1045L0 14.1882Z"
                fill="#004226"
            />
        </svg>
    );
};

export default HomeIcon;
